// Nunito, one weight per role (Brand Kit 1.0.0 § Typography, decision 52): 400 text, 500 numbers
// and amounts, 600 headings and subtotals, 700 titles and main results. Only these four are loaded,
// so nothing may ask for another: the browser would synthesise it.
import '@fontsource/nunito/400.css';
import '@fontsource/nunito/500.css';
import '@fontsource/nunito/600.css';
import '@fontsource/nunito/700.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { I18nextProvider } from 'react-i18next';
import { App } from './app/App';
import i18n from './i18n';
import { captureInstallPrompt } from './pwa/install';
import { registerServiceWorker } from './pwa/register-service-worker';
import './styles/globals.css';

captureInstallPrompt();
registerServiceWorker();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('#root element not found in index.html');
}

createRoot(rootElement).render(
  <StrictMode>
    <I18nextProvider i18n={i18n}>
      <App />
    </I18nextProvider>
  </StrictMode>,
);
